export default __webpack_public_path__ + "static/media/6.f521c36c.svg";